export function timeGuard<T>(
	task: () => Promise<T>,
	returnValueOnTimeout: T,
	timeout: number,
): Promise<T> {
	return Promise.race<T>([
		task(),
		new Promise((resolve) =>
			setTimeout(() => {
				resolve(returnValueOnTimeout);
			}, timeout),
		),
	]);
}
